// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DeleteProduct_wrapper__ng0VK","removeButton":"DeleteProduct_removeButton__n6DbG","removeButtonContent":"DeleteProduct_removeButtonContent__POvD6"};